/* esm.sh - @lit/reactive-element@2.1.2/decorators/state */
import{property as r}from"./property.mjs";function a(t){return r({...t,state:!0,attribute:!1})}export{a as state};
/*! Bundled license information:

@lit/reactive-element/decorators/state.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=state.mjs.map